import { mapState, mapActions, mapMutations } from 'vuex'
import Util from '../../util/funcoes'

export default {
  data() {
    return {
      isLoading: false
    }
  },

  created() {
    this.listar();
  },

  computed: {
    ...mapState('contasReceberAtrasadasStore', {
      contasReceberAtrasadas(state) { return state.listaDeContasReceberAtrasadas }
    }),

    tooltipQuantidadeContasIsVisible() {
      return this.contasReceberAtrasadas.length > 0;
    },

    quantidadeContas() {
      const quantidade = this.contasReceberAtrasadas.length;

      switch (quantidade) {
        case 1:
          return 'Exibindo 1 lançamento.'
        default:
          return `Exibindo ${quantidade} lançamentos.`
      }
    }
  },

  methods: {
    ...mapActions('contasReceberAtrasadasStore', [
      'recuperarContasReceberAtrasadas'
    ]),

    ...mapMutations('recuperarContasReceberAtrasadas', [
      'limparContasReceber'
    ]),

    listar() {
      this.showLoading();
      this.limparContasReceber();
      this.recuperarContasReceberAtrasadas()
      .then()
      .finally(() => {
        this.hideLoading();
      })
    },

    showLoading() {
      this.isLoading = true;
    },
    hideLoading() {
      this.isLoading = false;
    },

    formatarLabelValor(item) {
      return Util.formatarValor(item.valor);
    },
  }
}